'use client';

import '../../css/xoffi-auth.css'; // Laravel-Style CSS

export default function Layout({ children }) {
  return (
    <div className="auth-container">
      {children}
    </div>
  );
}
